<template>
    <v-card flat class="mb-3">
        <v-toolbar flat color="white">
            <v-toolbar-title class="subheading deep-purple--text text--accent-3">Labot mazgāšanas datus </v-toolbar-title>
        </v-toolbar>

        <v-divider class="deep-purple accent-3"></v-divider>


        <div>
            <v-layout row wrap>
                <v-flex xs12 xl8 offset-xl2>
                    <v-card flat class="mt-3 pa-1" v-if="inputData">
                        <v-form ref="form">
                            <v-flex xs12 >

                                <v-layout row wrap>

                                    <v-flex xs12 md6 >
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="cleaning.truck"
                                                color="deep-purple accent-3"
                                                item-text="reg_nr"
                                                return-object
                                                :items="inputData.trucks"
                                                label="Vilcējs"
                                        ></v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md6 v-if="cleaning.cleaned_item.type === 'Konteiners'">
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="cleaning.trailer"
                                                color="deep-purple accent-3"
                                                item-text="reg_nr"
                                                return-object
                                                :items="inputData.trailers"
                                                label="Piekabe"
                                        ></v-autocomplete>
                                    </v-flex>

                                </v-layout>


                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-select
                                                class="pa-3"
                                                v-model="cleaning.tank_compartments"
                                                color="deep-purple accent-3"
                                                :items="compartments"
                                                label="Sekcijas"
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12 md4>
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="cleaning.cargo"
                                                color="deep-purple accent-3"
                                                item-text="name"
                                                return-object
                                                :items="inputData.cargos"
                                                label="Krava"
                                                :rules="formRules"
                                                required
                                        ></v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md4>
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="cleaning.customer"
                                                color="deep-purple accent-3"
                                                item-text="name"
                                                return-object
                                                :items="inputData.companies"
                                                label="Klients"
                                                :rules="formRules"
                                                required
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>

                                    <v-flex xs12 md4 >
                                            <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            class="pa-3"
                                                            v-model="cleaning.cleaning_date"
                                                            label="Mazgāšanas datums"
                                                            prepend-icon="event"
                                                            readonly
                                                            v-on="on"
                                                            :rules="formRules"
                                                            required
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="cleaning.cleaning_date" @input="menu = false"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="cleaning.start_time"
                                                class="pa-3"
                                                label="Mazgāšana sākta"
                                                color="deep-purple accent-3"
                                                type="time"
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4 >
                                        <v-text-field
                                                v-model="cleaning.end_time"
                                                class="pa-3"
                                                label="Mazgāšana sākta"
                                                color="deep-purple accent-3"
                                                type="time"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-layout row wrap>

                                <v-flex xs12 md2 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="cleaning.cleaning_order_nr"
                                            label="Iekšējais pasūtījuma nr"
                                            color="deep-purple accent-3"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md2 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="cleaning.leftovers"
                                            type="number"
                                            label="Preču paliekas"
                                            color="deep-purple accent-3"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md8>
                                    <v-text-field
                                            class="pa-3"
                                            v-model="cleaning.additional_services"
                                            label="Piezīmes"
                                            color="deep-purple accent-3"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="ma-3">
                                    <v-alert
                                            :value="errorStatus"
                                            type="error"
                                    >
                                        {{ errorMessage }}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs6 md3 v-for="option in inputData.options" :key="option.id">
                                    <v-checkbox class="px-3" color="deep-purple accent-3" v-model="selectedCleaningOptions" :label="option.display_name" :value="option"></v-checkbox>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 class="mx-3 mb-3">
                                    <div class="text-xs-center text-md-right">
                                        <v-btn small flat @click="hideUpdateContainerForm" dark color="deep-orange lighten-1">
                                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                        <v-btn small flat @click="submit" dark color="info">Labot
                                            <v-icon dark right>check_circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>

        </div>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "update-cleaning",
        props: ['cleaning'],
        data: () => ({
            compartments: [ 1, 2, 3, 4, 5, 6, 7 ],
            menu: false,
            modal: false,
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        created() {
            this.$store.dispatch('resetErrors')
            this.$store.dispatch('getUpdateCleaningInputData')
        },
        computed: {
            ...mapGetters({
                inputData: 'cleaningInputData',
                errorStatus: 'errorStatus',
                errorMessage: 'errorMessage',
            }),
            selectedCleaningOptions: {
                get(){
                    return this.$store.getters.selectedCleaningOptions
                },
                set(options){
                    this.$store.dispatch('changeSelectedCleaningOptions', options)
                }
            }
        },
        methods: {
            hideUpdateContainerForm() {
                this.$store.dispatch('hideUpdateCleaningForm')
                this.$store.dispatch('getSingleCleaning', this.$route.params.id)
            },
            submit() {
                this.$Progress.start()
                        if (this.$refs.form.validate()) {
                            this.$store.dispatch('updateCleaning')
                            this.$parent.snackbar = true
                            this.$parent.color = 'info'
                            this.$parent.text = 'Mazgāšana labota'
                        } else {
                            this.$Progress.fail()
                        }

            }
        }

    }
</script>

<style scoped>

</style>